import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const ContextBar = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.25rem;
`

export const DeptChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
`

export const CardStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const ShiftCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
`

export const ShiftTitleGroup = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
`

export const ShiftWindowText = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const RowsStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
`

export const EditorRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.625rem;
  padding: 0.5rem 0.625rem;
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
`

export const CountStepper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
`

export const StepBtn = styled.button`
  width: 1.75rem;
  height: 1.75rem;
  display: grid;
  place-items: center;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.base};
  color: ${tokens.text.primary};
  cursor: pointer;

  &:hover {
    border-color: ${tokens.accent.base};
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`

export const CountValue = styled.span`
  min-width: 1.5rem;
  text-align: center;
  font-size: ${tokens.font.body};
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${tokens.text.primary};
`

export const TimesMark = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const CriticalToggle = styled.label<{ $on: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  font-size: ${tokens.font.micro};
  font-weight: 600;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: ${tokens.radius.chip};
  border: 1px solid ${({ $on }) => ($on ? tokens.status.danger.fg : tokens.border.hairline)};
  color: ${({ $on }) => ($on ? tokens.status.danger.fg : tokens.text.muted)};
  background: ${({ $on }) => ($on ? tokens.status.danger.bg : 'transparent')};
`

export const LocationChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: ${tokens.font.micro};
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  border-radius: ${tokens.radius.chip};
  border: 1px solid ${tokens.border.strong};
  color: ${tokens.text.secondary};
  background: ${tokens.surface.base};
`

export const RemoveRowBtn = styled.button`
  margin-left: auto;
  width: 1.75rem;
  height: 1.75rem;
  display: grid;
  place-items: center;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${tokens.border.hairline};
  background: transparent;
  color: ${tokens.text.muted};
  cursor: pointer;

  &:hover {
    color: ${tokens.status.danger.fg};
    border-color: ${tokens.status.danger.fg};
  }
`

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding-top: 0.625rem;
  border-top: 1px solid ${tokens.border.hairline};
  font-size: ${tokens.font.label};
  color: ${tokens.text.secondary};
`

export const CriticalNote = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.status.danger.fg};
`

export const MembersWarning = styled.div`
  font-size: ${tokens.font.micro};
  color: ${tokens.status.warning.fg};
`

export const SaveBar = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 1.25rem;
`

export const HintBanner = styled.div`
  padding: 0.75rem 1rem;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.inset};
  font-size: ${tokens.font.label};
  color: ${tokens.text.secondary};
  margin-bottom: 1rem;
`

export const VersionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  margin-top: 0.75rem;
`

export const VersionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  font-size: ${tokens.font.micro};
  color: ${tokens.text.secondary};
  padding: 0.375rem 0.625rem;
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
`

export const HelperText = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`
